/**
 * Enlace "Plataforma antigua" (/reservations/reservas-antiguas): solo usuarios
 * creados antes del 1 de mayo de 2024 (UTC).
 */
const LEGACY_RESERVA_ANTIGUAS_CUTOFF_MS = Date.UTC(2024, 4, 1, 0, 0, 0, 0);

const getUserCreatedAtMs = user => {
  const raw = user?.attributes?.createdAt;
  if (raw == null) {
    return null;
  }
  const d = raw instanceof Date ? raw : new Date(raw);
  const t = d.getTime();
  return Number.isNaN(t) ? null : t;
};

/**
 * @returns {boolean} false si el usuario se registró el 1 may 2024 o después (UTC).
 */
export const userCanSeeLegacyReservaAntiguas = user => {
  if (!user?.id) {
    return false;
  }
  const t = getUserCreatedAtMs(user);
  if (t == null) {
    return true;
  }
  return t < LEGACY_RESERVA_ANTIGUAS_CUTOFF_MS;
};
